<template>
  <row style="background: linear-gradient(to bottom, #0174EA, #013A75);width: 100%;" class="min-h-screen flex items-center justify-center relative">
    <template v-if="!contactData || contactData.length < 1">
      <FittLinkTree />
    </template>
    <template v-else>
      <PersonalLinkTreePage :contact-data="contactData" />
    </template>
  </row>
</template>

<script>
export default {
  name: "LinkTreePage.vue",
  components: {
    FittLinkTree: () => import('@/components/page/FittLinkTree.vue'),
    PersonalLinkTreePage: () => import('@/components/page/PersonalLinkTreePage.vue'),
  },
  data() {
    return {
      contactData: [],
    };
  },
  created() {
    let url = window.location.href;
    url = new URL(url);

    let param = '';
    if (url.searchParams.has('q')) {
      param = url.searchParams.get('q');
    }

    if (param !== '') {
      this.contactData = JSON.parse(atob(param));
    }
  },
};
</script>

<style scoped>
</style>
